import {
  Seat,
  ChartData,
  PickUpData,
  DropOffData,
} from "src/containers/chart/types";
import { Action, ChartFareBreakup, Types } from "./types";

export const setChartData = (payload: ChartData): Action => ({
  type: Types.SET_CHART_DATA,
  payload,
});

export const setSelectedSeats = (payload: Seat[]): Action => ({
  type: Types.SET_SELECTED_SEATS,
  payload,
});

export const setLoading = (payload: string): Action => ({
  type: Types.SET_LOADING,
  payload,
});
export const setFareBreakup = (payload: ChartFareBreakup): Action => ({
  type: Types.SET_FARE_BREAKUP,
  payload,
});
export const setSelectedPickup = (payload: PickUpData): Action => ({
  type: Types.SET_SELECTED_PICKUP,
  payload,
});
export const setSelectedDropoff = (payload: DropOffData): Action => ({
  type: Types.SET_SELECTED_DROPOFF,
  payload,
});
export const clearChartContext = (): Action => ({
  type: Types.CLEAR_CHART_CONTEXT,
  payload: null,
});
